// TermsConditionsPage.js
import React from "react";
import { useNavigate } from "react-router-dom";

const TermsConditionsPage = () => {
  const navigate = useNavigate();

  return (
    <div className="max-w-4xl mx-auto p-6">
      {/* Header with back button */}
      <div className="flex items-center mb-6">
        <button
          onClick={() => navigate("/dashboard/profile")}
          className="flex items-center text-blue-600 hover:text-blue-700 mb-4"
        >
          <svg
            className="w-5 h-5 mr-2"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M15 19l-7-7 7-7"
            />
          </svg>
          Back to Profile
        </button>
      </div>

      <h1 className="text-3xl font-bold text-gray-900 mb-6">
        Terms & Conditions
      </h1>

      <div className="prose max-w-none">
        <p className="text-gray-600 mb-4">
          Last updated: {new Date().toLocaleDateString()}
        </p>

        <div className="bg-gray-50 p-6 rounded-lg mb-6">
          <h2 className="text-xl font-semibold mb-3">Acceptance of Terms</h2>
          <p className="text-gray-700">
            By accessing and using this property management platform, you accept
            and agree to be bound by the terms and provision of this agreement.
          </p>
        </div>

        <div className="bg-gray-50 p-6 rounded-lg mb-6">
          <h2 className="text-xl font-semibold mb-3">Use License</h2>
          <p className="text-gray-700">
            Permission is granted to temporarily use this platform for personal,
            non-commercial property management purposes. This is the grant of a
            license, not a transfer of title.
          </p>
        </div>

        <div className="bg-gray-50 p-6 rounded-lg mb-6">
          <h2 className="text-xl font-semibold mb-3">User Responsibilities</h2>
          <p className="text-gray-700">
            You are responsible for maintaining the confidentiality of your
            account and password and for restricting access to your account.
          </p>
        </div>

        <div className="bg-gray-50 p-6 rounded-lg mb-6">
          <h2 className="text-xl font-semibold mb-3">
            Limitation of Liability
          </h2>
          <p className="text-gray-700">
            In no event shall the company be liable for any damages arising out
            of the use or inability to use the platform.
          </p>
        </div>

        <div className="bg-gray-50 p-6 rounded-lg">
          <h2 className="text-xl font-semibold mb-3">Contact Information</h2>
          <p className="text-gray-700">
            If you have any questions about these Terms & Conditions, please
            contact us through the Help & Support section.
          </p>
        </div>
      </div>
    </div>
  );
};

export default TermsConditionsPage;
